import { MediaItem } from "@/lib/media/shared";
import MediaStateOverlay from "./media-state-overlay";
import styles from "./media.module.css";

type Props = {
  media: MediaItem;
  children: React.ReactNode;
  theme?: "light" | "dark";
};

export default function MediaWrapper({
  media,
  children,
  theme = "light",
}: Props) {
  const isReady = media.Status === "READY";
  return (
    <div className={styles.wrapper}>
      {children || <div className={styles.placeholder} />}
      {!isReady && <MediaStateOverlay status={media.Status} theme={theme} />}
    </div>
  );
}
